<!-- <div class="pentagon-1"></div> -->
<!-- <div class="main-content"> -->
<!-- <div class="container-fluid"> -->
<div
  class="content"
  style="
    background-image: url(https://rfidngpsinventory.com/assets/img/loginBackgroundImg.png);
    background-position: center;
    background-size: cover;
  "
>
  <mat-card class="login-card" *ngIf="!showForgotPassword">
    <!-- <br /> -->
    <!-- Logo and Company Name -->
    <div class="logo-container">
      <div class="logo-img">
        <img
          [src]="baseUrlImage + 'assets/img/icons/rfidLogo.png'"
          style="width: 50px"
        />
      </div>
    </div>
    <h2 style="font-weight: bold">RFID Inventory</h2>
    <!-- Header with Login Name -->
    <div class="header" style="margin-top: -10%">
      <h3 style="font-weight: bold">Log In</h3>
    </div>

    <!-- Message -->
    <div class="message">
      <p>Enter your credential to access your account.</p>
    </div>

    <!-- Form -->
    <form class="login-form" [formGroup]="logInForm">
      <!-- Email Input -->
      <label class="formLabel">Email address</label>
      <mat-form-field class="full-width" appearance="outline">
        <input
          matInput
          placeholder="email@domain.com"
          type="email"
          required
          formControlName="email"
        />
        <mat-error *ngIf="logInForm.controls['email'].hasError('required')"
          >This field is mandatory</mat-error
        >
        <mat-error *ngIf="logInForm.controls['email'].hasError('email')"
          >Enter correct email format</mat-error
        >
      </mat-form-field>

      <!-- Password Input -->
      <label class="formLabel">Password</label>
      <mat-form-field class="full-width" appearance="outline">
        <input
          matInput
          placeholder="Password"
          [type]="password"
          required
          formControlName="password"
        />
        <span matSuffix (click)="onClick()"
          ><mat-icon class="material-symbols-outlined" *ngIf="show"
            >visibility</mat-icon
          >
          <mat-icon class="material-symbols-outlined" *ngIf="!show"
            >visibility_off</mat-icon
          >
        </span>

        <mat-error *ngIf="logInForm.controls['password'].hasError('required')"
          >This field is mandatory</mat-error
        >
      </mat-form-field>

      <!-- Login Button -->
      <button
        mat-raised-button
        class="full-width btn btn-primary"
        [disabled]="logInForm.invalid"
        (click)="onLogIn()"
      >
        Log In
      </button>
      <!-- Forgot Password Link -->
      <div class="forgot-password text-primary">
        <a (click)="onForgotPass()" style="font-weight: 900"
          >Forgot Password?</a
        >
      </div>
      <br />
    </form>
  </mat-card>

  <!-- Forgot Password -->
  <mat-card class="forgotpasswordCard card" *ngIf="showForgotPassword">
    <button
      mat-raised-button
      class="btn btn-info backBtn"
      (click)="onBack()"
      style="margin-top: 20px"
    >
      <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>

      Back
    </button>

    <!-- Logo and Company Name -->
    <div class="logo-container">
      <img
        [src]="baseUrlImage + 'assets/img/icons/rfidLogo.png'"
        style="width: 50px"
      />
      &nbsp;
      <span> <p class="company-name">RFID Inventory</p></span>
    </div>

    <!-- Header with Login Name -->
    <div class="header">
      <h3 style="font-weight: bold">Forgot Password</h3>
    </div>

    <!-- Message -->
    <div class="message" *ngIf="!passwordChanged && !otpVerified">
      <p>
        Enter the email address associated to <br />
        your acount to change your password
      </p>
    </div>

    <br />
    <form [formGroup]="forgotPassForm" class="forgotPassword-form">
      <div class="row" *ngIf="!passwordChanged && !otpVerified">
        <mat-form-field class="col-md-9" appearance="outline">
          <mat-label>Email</mat-label>
          <input
            matInput
            placeholder="email@domain.com"
            formControlName="email"
          />
          <mat-error
            *ngIf="forgotPassForm.controls['email'].hasError('required')"
            >This field is mandatory</mat-error
          >
          <mat-error *ngIf="forgotPassForm.controls['email'].hasError('email')"
            >Enter correct email format</mat-error
          >
          <mat-error
            *ngIf="forgotPassForm.controls['email'].hasError('whitespace')"
            >Email cannot contain space</mat-error
          >
        </mat-form-field>

        <button
          type="button"
          (click)="onSendOtp()"
          class="btn btn-info"
          mat-raised-button
        >
          Send OTP
        </button>
      </div>
      <h4 class="text-info" *ngIf="showVerifyOTP && !otpVerified">
        OTP valid only for :- {{ display }}
      </h4>
      <div
        class="row"
        style="margin-left: 10%"
        *ngIf="showVerifyOTP && !otpVerified"
      >
        <mat-form-field class="col-md-6" appearance="outline">
          <mat-label>Enter OTP</mat-label>
          <input matInput placeholder="Enter Otp" formControlName="otp" />
        </mat-form-field>
        <button
          type="button"
          (click)="onClickVerify()"
          class="btn btn-info"
          mat-raised-button
        >
          Verify Otp
        </button>
      </div>
      <div style="margin-left: 15%" *ngIf="otpVerified && !passwordChanged">
        <!--  -->
        <mat-form-field appearance="outline" class="col-md-10">
          <mat-label>Password</mat-label>
          <input
            matInput
            placeholder="Placeholder"
            name="password"
            type="password"
            formControlName="password"
          />

          <mat-icon
            matSuffix
            matTooltip="Passsword must be atleast minimum 8 character ,one capital letter, one small letter, one number and one special character"
            >info</mat-icon
          >
          <mat-error
            *ngIf="forgotPassForm.controls['password'].hasError('pattern')"
            >Enter correct password format</mat-error
          >
          <mat-error
            *ngIf="forgotPassForm.controls['password'].hasError('required')"
            >This field is mandatory</mat-error
          >
        </mat-form-field>
        <br />
        <mat-form-field appearance="outline" class="col-md-10">
          <mat-label>Confirm Password</mat-label>
          <input
            matInput
            placeholder="Placeholder"
            name="confirmPassword"
            [type]="confPassword"
            formControlName="confirmPassword"
            (keyup)="
              onCHangePassword(forgotPassForm.controls['confirmPassword'].value)
            "
          />
          <span matSuffix (click)="onCinfirmPassHideShow()"
            ><mat-icon class="material-symbols-outlined" *ngIf="confPassShow"
              >visibility</mat-icon
            >
            <mat-icon class="material-symbols-outlined" *ngIf="!confPassShow"
              >visibility_off</mat-icon
            >
          </span>
          <mat-error
            *ngIf="
              forgotPassForm.controls['confirmPassword'].hasError('required')
            "
            >This field is mandatory</mat-error
          >
        </mat-form-field>
        <mat-error *ngIf="isConfirmPasswordValid" style="margin-right: 12%"
          >Password and Confirm Password didn't match.
        </mat-error>
      </div>
      <br />
      <!--   -->
      <button
        *ngIf="otpVerified && !passwordChanged"
        (click)="onChangePassword()"
        class="btn btn-info"
        mat-raised-button
        style="width: 290px; margin-left: 18%"
        [disabled]="isConfirmPasswordValid"
        type="button"
      >
        Change Password
      </button>
    </form>
  </mat-card>
</div>
